import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { OrderService} from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import { InvoiceLine, SearchInvoiceLine, SearchQuoteOrder } from '../../models/models';

@Component({
    selector: 'invoice-line-grid',
    templateUrl: './invoice-line-grid.component.html',
    standalone: false
})
export class InvoiceLineGrid implements OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    //@Input() quoteOrderLineID: number = 0;
    @Input() orderNumber: string = "";
    @Input() viewType: string = "quoteorder";
    @Input() pageType: string = "";
    @Input() readonly: boolean = false;
    @Input() refreshDate: Date = new Date();
    @Output() onRefreshTotal = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public uiGrid!: GridComponent;

    public isNew: boolean = false;
    public isEdit: boolean = false;
    public searchOrder: SearchQuoteOrder = {} as SearchQuoteOrder;
    public invoiceLine: InvoiceLine = {} as InvoiceLine;
    public invoiceLineList: SearchInvoiceLine[] = [];
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'abbrev' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private orderService: OrderService, private utilService: UtilService, private ngZone: NgZone) { }

    ngOnInit() {
        //this.getInvoiceLines();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.orderService.getSearchQuoteOrderByID(this.quoteOrderID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.searchOrder = result.resultCollection[0];
            }
        });
        this.getInvoiceLines();
        //console.log("ngOnChanges");
    }

    private getInvoiceLines() {
        this.utilService.isLoading = true;
        this.invoiceLineList.length = 0;
        //if (this.quoteOrderLineID > 0 && this.viewType == "quoteorderline") {
        //    this.orderService.getSearchInvoiceLineByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
        //        this.utilService.isLoading = false;
        //        this.invoiceLineList = result.resultCollection;
        //        this.setGrid();
        //        this.getTotal();
        //        console.log("invoiceLineList:quoteOrderLineID", this.quoteOrderLineID, this.invoiceLineList.length);
        //    });
        //}
        if (this.orderNumber != null && this.orderNumber != "" && this.viewType == "ordernumber") {
            this.orderService.getSearchInvoiceLineByOrderNumber(this.orderNumber).subscribe(result => {
                this.utilService.isLoading = false;
                this.invoiceLineList = result.resultCollection;
                this.setGrid();
                this.getTotal();
                //console.log("invoiceLineList:orderNumber", this.orderNumber, this.invoiceLineList.length);
            });
        }
        if (this.quoteOrderID > 0 && this.viewType == "quoteorder") {
            this.orderService.getSearchInvoiceLineByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.utilService.isLoading = false;
                this.invoiceLineList = result.resultCollection;
                this.setGrid();
                this.getTotal();
                //console.log("invoiceLineList:quoteOrderID", this.quoteOrderID, this.invoiceLineList.length);
            });
        }
        else {
            this.utilService.isLoading = false;
        }
        this.invoiceLine = {} as InvoiceLine;
    }

    private getTotal() {
        var total = this.invoiceLineList.reduce(function (prev, cur) {
            return prev + (cur.invoiceAmount != null ? cur.invoiceAmount : 0);
        }, 0);
        this.onRefreshTotal.emit(total);
    }

    private setGrid() {
        this.gridData = process(this.invoiceLineList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.uiGrid == null) return;
            this.uiGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.invoiceLineList, this.gridState);
    }

    public canDelete(invoiceLine: SearchInvoiceLine) {
        if (invoiceLine.isAccessorialCharge == true) {
            return true;
        }
        else {
            return false;
        }
    }

    public addNew() {
        this.invoiceLine = {
            invoiceLineID: 0,
            quoteOrderID: this.quoteOrderID,
            //quoteOrderLineId: this.quoteOrderLineID,
            //orderNumber: this.orderNumber,
            invoiceLineTypeID: 0,
            quantity: 0,
            rate: 0,
            invoiceAmount: 0,
            createdByEmployeeID: this.utilService.getEmployeeID()
        };
    }

    public edit(invoiceLine: SearchInvoiceLine) {
        //console.log("edit", invoiceLine);
        this.orderService.getInvoiceLineByID(invoiceLine.invoiceLineID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.invoiceLine = result.resultCollection[0];
                this.invoiceLine.lastModifiedByEmployeeID = this.utilService.getEmployeeID();
            }
        });
        //this.invoiceLine = Object.assign({}, invoiceLine);
    }

    public delete(invoiceLine: SearchInvoiceLine) {
        //console.log("edit", invoiceLine);
        if (confirm("Delete " + invoiceLine.description + " (" + invoiceLine.abbrev + ")?")) {
            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Invoice Line Grid Delete");
            this.orderService.deleteInvoiceLineByID(invoiceLine.invoiceLineID).subscribe(result => {
                console.log("deleteInvoiceLine", result, invoiceLine);
                this.getInvoiceLines();
            });
        }
        //this.invoiceLine = Object.assign({}, invoiceLine);
    }
}
